import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * OpenControllerSvr
 */
export class OpenControllerSvr {
    constructor() {
        this.baseurl = 'OpenControllerSvr.assx/';
    }

    /**
     *
     * orgCode:String
     */
    getOwnerTeam(orgCode){
        return request.post(this.baseurl + 'getOwnerTeam', Qs.stringify({ orgCode:orgCode }));
    }

    /**
     * 
     * orgCode:String
     */
    getZjjOwnerTeamVoByorgCode(orgCode){
        return request.post(this.baseurl + 'getZjjOwnerTeamVoByorgCode', Qs.stringify({ orgCode:orgCode }));
    }
    
    /**
     *
     * orgCode:String
     */
     newGetOwnerTeam(orgCode){
        return request.post(this.baseurl + 'newGetOwnerTeam', Qs.stringify({ orgCode:orgCode }));
    }

    /**
     *
     * orgCode:String, ownerName:String, ownerPhone:String, idCard:String, startIndex:int, maxSize:int, returnTotalCount:boolean
     */
    getOwnerCommitteeMemberList(orgCode, ownerName, ownerPhone, idCard, startIndex, maxSize, returnTotalCount){
        return request.post(this.baseurl + 'getOwnerCommitteeMemberList', Qs.stringify({ orgCode:orgCode, ownerName:ownerName, ownerPhone:ownerPhone, idCard:idCard, startIndex:startIndex, maxSize:maxSize, returnTotalCount:returnTotalCount }));
    }


    /**
     * 因专门过滤其他人，不影响其他方法
     * orgCode:String, ownerName:String, ownerPhone:String, idCard:String, startIndex:int, maxSize:int, returnTotalCount:boolean
     */
    getOwnerCommitteeMemberListForOut(orgCode, ownerName, ownerPhone, idCard, startIndex, maxSize, returnTotalCount){
        return request.post(this.baseurl + 'getOwnerCommitteeMemberListForOut', Qs.stringify({ orgCode:orgCode, ownerName:ownerName, ownerPhone:ownerPhone, idCard:idCard, startIndex:startIndex, maxSize:maxSize, returnTotalCount:returnTotalCount }));
    }


    /**
     *
     * eaAreaCode:String
     */
    getOwnerTeamByEaAreaCode(eaAreaCode){
        return request.post(this.baseurl + 'getOwnerTeamByEaAreaCode', Qs.stringify({ eaAreaCode:eaAreaCode }));
    }

    /**
     *
     * orgCode:String, startIndex:int, maxSize:int
     */
    getEmployeeByOrgCode(orgCode, startIndex, maxSize){
        return request.post(this.baseurl + 'getEmployeeByOrgCode', Qs.stringify({ orgCode:orgCode, startIndex:startIndex, maxSize:maxSize }));
    }

    // /**
    //  *
    //  * eaAreaCode:String
    //  */
    // getPropertyManagerByEaAreaCode(eaAreaCode){
    //     return request.post(this.baseurl + 'getPropertyManagerByEaAreaCode', Qs.stringify({ eaAreaCode:eaAreaCode }));
    // }

    /**
     *
     * orgCode:String, eaAreaCode:String, name:String, orgNme:String, jobType:int, startIndex:int, maxSize:int
     */
    getEmployeeList(orgCode, eaAreaCode, name, orgNme, jobType, startIndex, maxSize){
        return request.post(this.baseurl + 'getEmployeeList', Qs.stringify({ orgCode:orgCode, eaAreaCode:eaAreaCode, name:name, orgNme:orgNme, jobType:jobType, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     *
     * orgCode:String
     */
    getRealtyMgeComDetail(orgCode){
        return request.post(this.baseurl + 'getRealtyMgeComDetail', Qs.stringify({ orgCode:orgCode }));
    }

    /**
     *
     * cantonCode:String, streetCode:String, streetName:String, startIndex:int, maxSize:int
     */
    getStreetOfficeListByCantonCode(cantonCode, streetCode, streetName, startIndex, maxSize){
        return request.post(this.baseurl + 'getStreetOfficeListByCantonCode', Qs.stringify({ cantonCode:cantonCode, streetCode:streetCode, streetName:streetName, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     *
     * streetCode:String, residentsCode:String, residentsName:String, startIndex:int, maxSize:int
     */
    getResidentsCommitteeListByStreetCode(streetCode, residentsCode, residentsName, startIndex, maxSize){
        return request.post(this.baseurl + 'getResidentsCommitteeListByStreetCode', Qs.stringify({ streetCode:streetCode, residentsCode:residentsCode, residentsName:residentsName, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     *
     * cantonCode:String, isChild:boolean
     */
    getCantonList(cantonCode, isChild){
        return request.post(this.baseurl + 'getCantonList', Qs.stringify({ cantonCode:cantonCode, isChild:isChild }));
    }

    /**
     *
     * cantonCode:String, streetCode:String, committeeCode:String, eaAreaName:String, startIndex:int, maxSize:int
     */
    getEaAreaList(cantonCode, streetCode, committeeCode, eaAreaName, startIndex, maxSize){
        return request.post(this.baseurl + 'getEaAreaList', Qs.stringify({ cantonCode:cantonCode, streetCode:streetCode, committeeCode:committeeCode, eaAreaName:eaAreaName, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     *
     * employeeNumber:String
     */
    getEmployeeDetail(employeeNumber){
        return request.post(this.baseurl + 'getEmployeeDetail', Qs.stringify({ employeeNumber:employeeNumber }));
    }

    /**
     *
     *
     */
    getBankList(){
        return request.post(this.baseurl + 'getBankList', Qs.stringify({  }));
    }

    /**
     *
     * orgCode:String, startIndex:int, maxSize:int
     */
    getPrejectList(orgCode, startIndex, maxSize){
        return request.post(this.baseurl + 'getPrejectList', Qs.stringify({ orgCode:orgCode, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     *
     * objectId:String, objectType:int, specificType:int, startIdnex:int, maxSize:int
     */
    queryIntegrityInfo(objectId, objectType, specificType, startIdnex, maxSize){
        return request.post(this.baseurl + 'queryIntegrityInfo', Qs.stringify({ objectId:objectId, objectType:objectType, specificType:specificType, startIdnex:startIdnex, maxSize:maxSize }));
    }

    /**
     *
     *
     */
    GetVersion(){
        return request.post(this.baseurl + 'GetVersion', Qs.stringify({  }));
    }

    /**
     *
     * realtyMgeComName:String, realtyMgeComRegisteredArea:String, realtyMgeComAddress:String, startIndex:int, maxSize:int
     */
    getRealtyMgeComVoList(realtyMgeComName, realtyMgeComRegisteredArea, realtyMgeComAddress, startIndex, maxSize){
        return request.post(this.baseurl + 'getRealtyMgeComVoList', Qs.stringify({ realtyMgeComName:realtyMgeComName, realtyMgeComRegisteredArea:realtyMgeComRegisteredArea, realtyMgeComAddress:realtyMgeComAddress, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     *
     *
     */
    getCantonTree(){
        return request.post(this.baseurl + 'getCantonTree', Qs.stringify({  }));
    }
    /**
     *
     * eaAreaCode:String, startIndex:int, maxSize:int
     */
    getZjjOwnerTeamVoByEaAreaCode(eaAreaCode){
        return request.post(this.baseurl + 'getZjjOwnerTeamVoByEaAreaCode', Qs.stringify({ eaAreaCode:eaAreaCode}));
    }
    /**
     * startIndex 查询起始条数 maxSize当页数量  yzdhmc 业主大会名称 tyshxydm 统一社会信用代码
     * eaAreaCode:String, startIndex:int, maxSize:int
     */
    getZjjOwnerTeamVoListByYzdhmcOrTyshxydm(startIndex, maxSize, yzdhmc, tyshxydm,ownerTeamName){
        return request.post(this.baseurl + 'getZjjOwnerTeamVoListByYzdhmcOrTyshxydm', Qs.stringify({ startIndex:startIndex, maxSize:maxSize, yzdhmc:yzdhmc, tyshxydm:tyshxydm,ownerTeamName:ownerTeamName        }));
    }

    /**
     * 获取物业项目详情
     * String unifiedSocialCreditCode
     */
    getZjjOwnerTeamVoByUnifiedSocialCreditCode(unifiedSocialCreditCode) {
        return request.post(this.baseurl + 'getZjjOwnerTeamVoByUnifiedSocialCreditCode', Qs.stringify({ unifiedSocialCreditCode: unifiedSocialCreditCode }));
    }
}
